var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyCustomerManagement = function SvgImgEmptyCustomerManagement(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.921,
    height: 59.112,
    x: 4.648,
    y: 5,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 17.96
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.694 52.338a14.076 14.076 0 0 0-3.128-1.327v-5.225h-7.761v5.225c-1.093.315-2.144.76-3.129 1.328a14.285 14.285 0 0 0-5.822 6.352c1.928 3.586 7.762 3.434 12.68 3.434 4.917 0 10.957.713 12.983-3.434a14.285 14.285 0 0 0-5.823-6.353zm-4.234 2.794s-.576-1.102 2.86-.658m-8.597.658s.577-1.102-2.86-.658m13.163-1.93v6.727m-14.829-6.727v6.727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.107 59.342c-2.287.184-4.79.286-7.42.286a93.42 93.42 0 0 1-7.519-.294c-.462.985-2.959 1.784-6.241 2.04a13.986 13.986 0 0 0-.379 3.225V77.43h28.274V64.599c0-1.083-.127-2.162-.376-3.216-3.323-.247-5.862-1.05-6.339-2.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.107 59.342c.477.991 3.016 1.794 6.339 2.041a14.05 14.05 0 0 0-.929-2.692M9.854 58.69c-.399.862-.71 1.761-.927 2.685 3.282-.257 5.78-1.056 6.241-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M30.107 59.342c-2.287.184-4.79.286-7.42.286a93.42 93.42 0 0 1-7.519-.294c-.462.985-2.959 1.784-6.241 2.04a13.986 13.986 0 0 0-.379 3.225V77.43h28.274V64.599c0-1.083-.127-2.162-.376-3.216-3.323-.247-5.862-1.05-6.339-2.04z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.467,
    height: 35.46,
    x: 7.452,
    y: 13.316,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 11.716
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.712 30.887a4.753 4.753 0 0 0 4.739 4.74v-9.48a4.753 4.753 0 0 0-4.74 4.74zm35.212-4.739v9.478a4.74 4.74 0 0 0 0-9.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m24.624 15.497-6.217 5.504s-6.727 2.65-7.236 2.548c-1.79.303-3.559.711-5.3 1.223l.917-6.013 3.771-4.994s2.854-2.242 4.485-2.446c1.63-.204 7.44-1.121 7.44-1.121l4.892.815 3.77 1.121 3.16 2.039 2.344 2.242 1.733 3.873.917 3.872s-.204.51-.51.306c-.305-.204-6.42-1.936-6.42-1.936l-4.79-2.752-2.14-3.77-.816-.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.629 15.803c-.342 5.028-8.551 9.052-18.635 9.052M24.747 15.6c.263 5.027 6.586 9.05 14.354 9.05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.718,
    cy: 30.683,
    r: 1.769,
    fill: "#BDBDBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.312,
    cy: 30.683,
    r: 1.769,
    fill: "#BDBDBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M27.129 43.16a5.128 5.128 0 0 0-4.614-3.166 5.128 5.128 0 0 0-4.614 3.166h9.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m32.573 35.473 1.53.917m-.765-1.987 1.529.917m-24.269.077 1.528.917m-.764-1.987 1.529.917M48.688 7.69H64.54c5.631 0 10.197 4.565 10.197 10.197v6.192c0 5.631-4.566 10.197-10.197 10.197H48.688c-5.631 0-10.197-4.566-10.197-10.197v-6.192c0-5.632 4.566-10.197 10.197-10.197zm7.831 41.487c-8.17.024-14.787 6.64-14.811 14.81v13.444h29.621V63.987c-.024-8.17-6.64-14.786-14.81-14.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M56.518 54.987a4.077 4.077 0 0 0 4.066-4.065v-6.644h-8.131v6.644a4.077 4.077 0 0 0 4.065 4.065z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.919,
    height: 37.425,
    x: 40.559,
    y: 9.985,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 12.274
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.593 28.67a4.98 4.98 0 0 0 4.965 4.964v-9.93a4.98 4.98 0 0 0-4.965 4.965zm36.89-4.966v9.93a4.965 4.965 0 0 0 0-9.93z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.219,
    cy: 28.456,
    r: 1.853,
    fill: "#BDBDBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.461,
    cy: 28.456,
    r: 1.853,
    fill: "#BDBDBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M61.174 41.527a5.18 5.18 0 0 0-9.667 0h9.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52.453 50.025v27.013m8.131-27.213v27.013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M41.708 63.987v13.444h10.745V49.752a14.866 14.866 0 0 0-10.745 14.235zm29.622 0a14.866 14.866 0 0 0-10.746-14.235v27.679h10.745V63.987z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m65.185 63.585-1.898 9.503m-15.453-9.503 1.898 9.503M69.574 4.753c0-.61-.148-1.212-.43-1.753a3.852 3.852 0 0 1-3.414 2.09h-18.9a3.853 3.853 0 0 0-3.834 3.676c-.003.056-.009.112-.009.169v3.843a3.855 3.855 0 0 0 3.844 3.844H65.73a3.855 3.855 0 0 0 3.844-3.844V8.935c0-.057-.007-.113-.01-.17.003-.056.01-.111.01-.168V4.753zm-6.471 55.202h3.523"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyCustomerManagement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-customer-management.cfc71e85a7461b1619624510a048999d.svg";